module.exports = __webpack_public_path__ + "img/activ8-sticker-4.89fdcc85.png";